import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import Index from "@/views/Index.vue";
import Tournaments from "@/views/Tournaments.vue";
import Games from "@/views/Games.vue";
import Store from "@/views/Store.vue";
import Profile from "@/views/Profile.vue";
import GameWrapper from "@/views/GameWrapper.vue";
import Login from "@/views/Login.vue";
import EmailLogin from "@/views/EmailLogin.vue";
import EmailRegistration from "@/views/EmailRegistration.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import PasswordReset from "@/views/PasswordReset.vue";
import VerifyEmail from "@/views/VerifyEmail.vue";
import TournamentInfo from "@/views/TournamentInfo.vue";
import LeagueDescriptions from "@/views/LeagueDescriptions.vue";
import PrivacyPolicy from "@/views/PrivacyPolicy.vue";
import TermsOfUse from "@/views/TermsOfUse.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        component: Index,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/tournaments/:tab?',
        name: 'tournaments',
        component: Tournaments,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/tournaments/info/:id',
        name: 'tournamentInfo',
        component: TournamentInfo,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/games',
        name: 'games',
        component: Games,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/games/:id',
        name: 'gameWrapper',
        component: GameWrapper,
        meta: {requiresAuth: true, roles: [], containerClass: 'game-wrapper'},
    },
    {
        path: '/store/:tab?',
        name: 'store',
        component: Store,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/login/email',
        name: 'emailLogin',
        component: EmailLogin,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/registration',
        name: 'registration',
        component: EmailRegistration,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/password-reset',
        name: 'forgotPassword',
        component: ForgotPassword,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/password-reset/:token',
        name: 'passwordReset',
        component: PasswordReset,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/verify-email/:token',
        name: 'verifyEmail',
        component: VerifyEmail,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: {requiresAuth: true, roles: []},
    },
    {
        path: '/profile/leagues',
        name: 'leagueDescriptions',
        component: LeagueDescriptions,
        meta: {requiresAuth: true, roles: []},
    },
    {
        path: '/privacy',
        name: 'privacyPolicy',
        component: PrivacyPolicy,
        meta: {requiresAuth: false, roles: []},
    },
    {
        path: '/terms',
        name: 'termsOfUse',
        component: TermsOfUse,
        meta: {requiresAuth: false, roles: []},
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router

